import {Injectable} from '@angular/core';
import {Service} from '../../common/service.class';
import {PremedicalEducation} from './premedical-education.model';
import {UserModelService} from '../../common/user-model.service';

/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
@Injectable()
export class PremedicalEducationService extends UserModelService<PremedicalEducation> {

    constructor(svcm: Service.InjectedMembers) {
        super(svcm, 'premedicalEducation', PremedicalEducation);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/education/premedical/premedical-education.service.ts